module.exports = __webpack_public_path__ + "img/image1.8922138d.png";